import '../assets/css/index.css'
const Loading = () => {
    return <div className='mt-8 d-flex flex-column justify-center align-items-center gap-2'>
        <div className='loading-container'>
            <div className="dots">
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
        <h3>Loading...</h3>
    </div>
}
export default Loading